// src/components/Time.jsx
import React, { useState, useEffect } from "react";

export default function Time() {
  const [now, setNow] = useState(new Date());
  const dateString =
    `${now.getFullYear()}年${String(now.getMonth() + 1).padStart(
      2,
      "0"
    )}月${String(now.getDate()).padStart(2, "0")}日 ` +
    now.toLocaleDateString("zh-TW", { weekday: "long" });

  // 每秒更新時間
  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const session = getSessionStatus(now);

  return (
    <section className="time-section">
      <div className="time-inner">
        <div className="time-date">{dateString}</div>
        <div className="time-clock">
          {now.toLocaleTimeString("zh-TW", { hour12: false })}
        </div>
        <div className={`time-status ${session.isOpen ? "open" : "closed"}`}>
          <img
            src={session.icon}
            alt={session.label}
            // style={{ width: 24, height: 24, objectFit: "contain" }}
          />
        </div>
      </div>
    </section>
  );
}

// 判斷看診時段
function getSessionStatus(date) {
  const current = date.getHours() * 60 + date.getMinutes(); // 換成總分鐘
  const ranges = [
    {
      start: toMinutes(8, 30),
      end: toMinutes(12, 0),
      label: "早診",
      icon: "/icons/morning-shift-icon.png",
    },
    {
      start: toMinutes(14, 30),
      end: toMinutes(17, 30),
      label: "午診",
      icon: "/icons/noon-shift-icon.png",
    },
    {
      start: toMinutes(18, 30),
      end: toMinutes(21, 30),
      label: "晚診",
      icon: "/icons/night-shift-icon.png",
    },
  ];

  for (const r of ranges) {
    if (current >= r.start && current <= r.end) {
      return { isOpen: true, label: r.label, icon: r.icon };
    }
  }
  return { isOpen: false, label: "休診中", icon: "/icons/off-shift-icon.png" };
}

function toMinutes(h, m) {
  return h * 60 + m;
}
